<template>
    <div class="app_comment_layout">

        <div v-if="commentList.length > 0">

            <div v-for="(item, index) in commentList" class="item_comment_layout_column" style="margin-bottom: 12px;"
                :key="index">

                <div class="item_comment_layout">

                    <img v-if="item.user.avatar" :src="item.user.avatar" class="user_logo">

                    <img v-else :src="defheader_img" class="user_logo" />

                    <div class="item_comment_layout_column_flex">
                        <div class="comment_name_layout">
                            <div class="user_name">{{ item.user.nickname }}</div>
                            <star-rating v-show="item.score != '' && item.score != 0" :rating="item.score"
                                :read-only="true" :show-rating="false" :increment="0.1" :star-size="14"
                                style="margin-left: 4px; margin-right: 4px;margin-bottom: 4px;" />
                            <div class="relo_comment" v-if="item.user.role">
                                {{ item.user.role }}
                            </div>
                            <div class="comment_time">{{ item.comment.comment_date }}</div>

                        </div>

                        <div class="comment_data">{{ item.comment.comment_content }}</div>

                        <div class="item_comment_layout_row">

                            <div class="comment_good_layout" @click="addGood(item)">
                                <img :src="imgGoodf" v-if="item.isGood" class="goodIcon_layout">
                                <img :src="imgGood" v-else class="goodIcon_layout">
                                <div>{{ item.good }}</div>
                            </div>
                            <div class="comment_good_layout" style="margin-left: 40px;" @click="clickDetaInfo(item)"
                                v-show="!item.replay">
                                <img :src="imgreply" class="goodIcon_layout">
                                <div>Reply</div>
                            </div>
                        </div>



                        <div v-show="item.replies.length > 0" class="relayout_container">
                            <div v-for="(childItem, xIndex) in item.replies" class="item_comment_layout_column"
                                style="margin-bottom: 12px;" :key="xIndex">
                                <div class="item_comment_layout" v-if="xIndex < 5">

                                    <!-- <img v-if="childItem.user.avatar" :src="item.user.avatar" class="user_chilid_logo">

                                    <img v-else :src="defheader_img" class="user_chilid_logo" /> -->

                                    <div class="item_comment_reply_layout_column_flex">
                                        <div class="reply_user_name">{{ childItem.user.nickname }}:</div>

                                        <div class="comment_reply_data">{{ childItem.comment.comment_content }}</div>

                                        <!-- <div class="item_comment_layout_row">

                                            <div class="comment_time">{{ childItem.comment.comment_date }}</div>
                                            <div>{{ childItem.comment.comment_author_IP }}</div>
                                        </div> -->

                                    </div>

                                </div>


                            </div>

                            <div v-show="item.replies.length > 0">
                                <div class="rep_number_layout" @click="clickDetaInfo(item)">Total of {{
                                    item.replies.length }}
                                    Reply{{ rRight }}
                                </div>
                            </div>

                            <div class="child_comment_line">

                            </div>



                        </div>




                    </div>

                    <div></div>

                </div>



                <div class="bee_comment_re_layout" style="margin-top: 16px" v-show="item.replay">
                    <textarea class="inputLayoutStyle_child" v-model="item.repContent" placeholder="Please enter a comment"> </textarea>
                    <div class="re_comment" @click="reComment(item)">Post</div>
                </div>


                <div class="comment_line"></div>


            </div>

        </div>

        <div v-else>

            <div class="empty_layout">
                <div class="empty_div"></div>
                <div class="empty_txt"> No comments</div>
            </div>

        </div>


        <pageView :count="count" @pageCheck="pageLisenter"></pageView>


    </div>
</template>

<script>
import {
    base_url,
    getPostId
} from "../util/comment_mock.js"
import Toast from "../components/message.js";
import StarRating from "vue-star-rating";
import defheader from '../assets/default_avatar.png';
import { AccountStore } from "../util/Account.js";
import goodIcon from '../assets/good.png';
import replyIcon from '../assets/replies.png';
import goodfIcon from '../assets/icon_goodf.png';
import { addEmit, resultEmitEvent } from "../util/event";
import pageView from './pageView.vue';

export default {
    name: 'commentView',
    props: {

    },
    emits: ['clickMore'],
    components: { StarRating, pageView },


    data() {
        return {
            imgGood: "",
            imgGoodf: "",
            imgreply: "",
            defheader_img: "",
            commentList: [

            ],
            post_id: '',
            rRight: '>',
            count: 0,
            page: 1,
            commentType: 0,
        }
    },

    watch: {

    },

    methods: {

        async reComment(item) {
            console.log(this.post_id + "===this.post_id")

            if (this.post_id == undefined || this.post_id == "") {
                Toast("postId Cannot be empty", "error");
                return;
            }
            if (item.repContent == undefined || item.repContent == "") {
                Toast("Comment content cannot be empty", "error");
                return;
            }
            if (AccountStore.accountInfo == null) {
                Toast("Please login before commenting", "error");
                window.location.href = AccountStore.loginUrl;
                return;
            }
            // console.log(item.repContent + "======");
                        var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_user_post_comment_score_callback',
                    post_id: this.post_id,
                    comment_content: item.repContent,
                    comment_parent: item.comment.comment_ID,
                    userInfo: e_mail,
                }),
            };

            const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json();

            // console.log(data);
            //Toast("提交成功", "success");
            item.replay = false;
        },


        async getPostComment() {
             var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_get_post_comment_callback',
                    _wpnonce: "wp_nonce",
                    post_id: this.post_id,
                    page: this.page,
                    type: this.commentType,
                    userInfo: e_mail,
                }),
            };
            const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json()
            // console.log(data);
            if (data.data.code == 200) {
                this.commentList = data.data.data;
                this.count = data.data.count;
                addEmit("comment_count", this.count);
            } else {
                Toast(data.data.message, 'error');
            }

        },

        pageLisenter(p) {
            this.page = p;
            // console.log(this.page + "===page")
            this.getPostComment();
        },
        clickDetaInfo(item) {
            this.$emit("clickMore", item);
        },
        async addGood(item) {
            if (this.post_id == undefined || this.post_id == "") {
                Toast("postId Cannot be empty", "error");
                return;
            }
            if (AccountStore.accountInfo == null || AccountStore.accountInfo.user_id == undefined
                || AccountStore.accountInfo.user_id == null) {
                // Toast("Please log in first", "error");
                window.location.href = AccountStore.loginUrl;
                return;
            }
            var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_rest_post_add_comment_good_callback',
                    _wpnonce: "wp_nonce",
                    comment_id: item.comment.comment_ID,
                     userInfo: e_mail,
                }),
            };
            const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json()
            // console.log(data);
            if (data.data.code == 200) {
                Toast("success", "success");
                if (item.isGood) {
                    item.isGood = false;
                    item.good = item.good - 1;
                } else {
                    item.good = item.good + 1;
                    item.isGood = true;
                }
            } else {
                Toast(data.data.message, 'error');
            }

        }



    },

    mounted() {
        this.imgGood = goodIcon;
        this.imgGoodf = goodfIcon;
        this.defheader_img = defheader;
        this.imgreply = replyIcon;
        this.post_id = getPostId();
        this.getPostComment();
        resultEmitEvent("commentTypeListener", (res) => {
            this.page = 1;
            if (res == 0) {
                this.commentType = 0;
            } else if (res == 1) {
                this.commentType = 1;
            }
            this.getPostComment();
        });
    },


}

</script>

<style scoped>
.app_comment_layout {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding-bottom: 16px;
    padding-top: 16px;
}

.item_comment_layout {
    display: flex;
    flex-direction: row;
}

.item_comment_layout_row {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.item_comment_layout_column_flex {
    display: flex;
    flex-direction: column;
    flex: 1;
}


.item_comment_reply_layout_column_flex {
    display: flex;
    flex-direction: row;
    flex: 1;
}

.item_comment_layout_column {
    display: flex;
    flex-direction: column;
}

.user_logo {
    width: 38px;
    height: 38px;
    border-radius: 100%;
    margin-right: 8px;
}

.user_chilid_logo {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    margin-right: 8px;
}

.comment_time {
    color: #6c757d !important;
    font-size: 12px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.comment_data {
    font-size: 16px !important;
    color: #333;
    margin-top: 8px;
    margin-bottom: 6px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
}

.comment_reply_data {
    font-family: SF Pro Text;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.09px;
    text-align: left;
    color: #333;
}

.user_name {
    font-size: 16px !important;
    color: #666666;
    font-family: SF Pro Text;
    font-weight: 500;
    line-height: 19.09px;
    text-align: left;
}

.reply_user_name {
    font-size: 16px !important;
    color: #0078B2;
    font-family: SF Pro Text;
    font-weight: 400;
    line-height: 19.09px;
    text-align: left;
    margin-right: 4px;
}

.re_comment {
    font-size: 16px !important;
    color: #1d232b;
    width: 46px;
    margin-left: 8px;
}

.inputLayoutStyle_child {
    display: flex;
    min-height: 48px;
    background-color: #f8f8f8;
    border-radius: 8px;
    width: -webkit-fill-available;
    width: -moz-available;
    border-color: #f8f8f8;
    padding: 4px;
}

.bee_comment_re_layout {
    display: flex;
    flex-direction: row;
    align-items: end;
    margin-top: 8px;
}

.comment_line {
    background-color: #f5f5f5;
    height: 2px;
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 8px;
}

.rep_number_layout {
    color: #0078B2;
    font-family: SF Pro Text;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.09px;
    text-align: left;
}

.relayout_container {
    background-color: #f6f6f6;
    margin-top: 6px;
    flex-direction: column;
    display: flex;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
}

.comment_name_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.child_comment_line {
    background-color: #ffffff;
    height: 1px;
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 4px;
}

.empty_div {
    width: 154px;
    height: 128px;
    background-image: url("../assets/noData.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.empty_layout {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.empty_txt {
    color: #444;
    font-size: 16px;
    margin-top: 6px;
}

.goodIcon_layout {
    width: 16px;
    height: 16px;
    margin-right: 6px;
}

.comment_good_layout {
    color: #6c757d !important;
    font-size: 14px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.relo_comment {
    border-radius: 4px;
    border: 0.5px solid #FFAC13;
    padding-top: 2px;
    padding-bottom: 2px;
    padding: 2px 4px;
    font-family: SF Pro Text;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.32px;
    color: #FFAC13;
    margin-left: 4px;
    margin-right: 4px;
}
</style>